import React from 'react';
import ChatContainer from '../components/Chat/ChatContainer';
import styled from 'styled-components';

const ChatPageContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const ChatPage: React.FC = () => {
  return (
    <ChatPageContainer>
      <ChatContainer />
    </ChatPageContainer>
  );
};

export default ChatPage;
